<template>
    <div class="m-footer">
        <div>
            <img :src="require('@/assets/img/footer_des.png')">
        </div>
    </div>
</template>

<script>

    export default {
        components: {},
        name: "MFooter",
        data() {
            return {
            }
        },
        computed: {
        },
        mounted() {
        },
        methods: {

        }
    }
</script>

<style scoped lang="stylus">
    .m-footer {
        height 80px
        background-color #002A5A
        display flex
        align-items center
        color white
        padding 0 10%
        justify-content center
        >div:first-child {
            min-width 453px
            width 453px
            height 17px
            >img {
                width 100%
                height 100%
            }
        }
    }
</style>
